<template>
  <div class="job-search-nav">
    <ul class="d-flex justify-content-between">
      <li>
        <span
          :class="{ 'is-active' : active === 'basic' }"
          @click="onTabChange('basic')"
        >
          ค้นหาจากลักษณะงาน
        </span>
      </li>

      <li>
        <span
          :class="{ 'is-active' : active === 'advanced' }"
          @click="onTabChange('advanced')"
        >
          ค้นหาจากคำค้น
        </span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data: () => ({
    active: 'basic'
  }),

  methods: {
    onTabChange(tab) {
      this.active = tab
      this.$emit('eventTabChange', tab)
    }
  }
}
</script>
<style lang="scss" scoped>
ul {
  padding: 0;
  margin: 0 0 3.5rem;
  list-style: none;
  text-align: center;
  border-bottom: solid 1px #cfd1d2;

  li {
    width: 50%;

    span {
      position: relative;
      color: #919396;
      font-size: 1.5rem;
      font-weight: 600;
      line-height: 1;
      cursor: pointer;
      display: block;
      padding: 1.5rem 0;

      &::after {
        position: absolute;
        width: 100%;
        left: 0;
        height: 3px;
        bottom: -2px;
        background: #1a4a99;
        opacity: 0;
        content: '';
      }

      &.is-active {
        color: #1a4a99;

        &::after {
          opacity: 1;
        }
      }
    }
  }
}
</style>
